import "./style.scss";
import OliverText from "../OliverText";


interface YoutubeButtonProps {
    text?: string;
    icon?: string;
    link?: string;
    styles?: React.CSSProperties;
}

const YoutubeButton = ({ text, icon, link, styles }: YoutubeButtonProps) => {
    return (
        <a href={link} target="_blank" rel="noreferrer" className="youtube-button" style={styles}>
            {<img src={icon || "/circle-play.svg"} alt={text} />}
            <OliverText text={text || "Watch tutorial"} size="xs" weight="medium" translatePrefix="generalComponents.button." color="blue" />
        </a>
    );
};

export default YoutubeButton;
